module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/search_white-fb8df219aa12fe677eb480ca224e9c79.svg";